const defaultAvailablePoints = [];

export default defaultAvailablePoints;
